import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import type { TrackingOptions } from '@frontend/call-intel-core';

export const PATIENT_INSIGHT_TEASER_FF = 'call-intel:patient-insight-teaser';
export const PATIENT_INSIGHT_TEASER_VARIANT_B_FF = 'call-intel:patient-insight-teaser-variant-b';
export const PATIENT_INSIGHT_PERMISSION = Permission.CALL_CLASSIFICATION_READ;
export const PATIENT_INSIGHT_TEASER_COMPONENT_ID = 'call-intel:patient-insight-teaser';

export const TRACKING_BASE: TrackingOptions = {
  component: 'patient-insights',
  page: 'contact-panel',
};
